<!--
 * @Author: your name
 * @Date: 2021-12-03 07:49:45
 * @LastEditTime: 2021-12-28 18:42:46
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: \new-website-1123\src\views\special\fx101\page1.vue
-->
<template>
  <div class="fx101-page1">
    <div class="text-div">
      <span class="model-span din">ST-LD/FX</span>
      <span class="label-span">太阳能路灯捕虫器</span>
    </div>
    <div class="img-div">
      <img
        src="https://stkjiot.com/resources/special/stld/1.png"
        alt="上太科技"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.fx101-page1 {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 200vh;
  .img-div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    img {
      height: 100%;
      margin-top: 20vh;
      // width: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      object-fit: contain;
      // object-fit: cover;
    }
  }
  .text-div {
    position: absolute;
    top: 10vh;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    .model-span {
      font-size: 84px;
      font-weight: 500;
      color: #ffffff;
    }
    .label-span {
      font-size: 36px;
      font-weight: bold;
      color: #ffffff;
      margin-top: 20px;
    }
  }
}

@media screen and (max-width: $mobile-width) {
  .fx101-page1 {
    position: relative;
    height: unset;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-top: $mobile-header-height + 20px;
    .img-div {
      position: relative;
      height: unset;
      img {
        display: block;
        height: unset;
        margin-top: 0;
        width: 100%;
        // width: 100%;
        position: relative;
        left: 0;
        transform: translateX(-0);
        object-fit: contain;
        // object-fit: cover;
      }
    }
    .text-div {
      position: relative;
      top: 0;
      left: 0;
      transform: translateX(-0);
      .model-span {
        font-size: 0.76rem;
      }
      .label-span {
        font-size: 0.33rem;
        margin-top: 10px;
      }
    }
  }
}
</style>
